import React, { useState } from "react";
import { Row, Col, Divider, Button } from "antd";
import "./style.css";
import { CustomLabel, BookAppointmentSmallButton, BookOutlinedButton, SubmitHealthButton } from "../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  currentStatus_Key,
  DocumentType_key,
  Document_key,
  pendingStatus_Key,
  pendingWith_key,
  status_code_constant_data,
  getAppointmentWiseStatus,
} from "../../../Constant";
import FooterButton from "../../../Pages/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SET_UPLOAD_FLOW } from "../../../Redux/PolicyNumber/types";
import { PolicyDetails } from "../../../Pages/Tracker/CommonData";
import { encrypt } from "../../../Services/AESEncryptionDecryption";
import TeleModal from "../../TeleModal";
import { checkDecisionPendingCode } from "../../../Utils";

const PendingTable = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const null_condition = [
    {
      DocCategoryCd: "IDENTITYPROOF",
      DocumentCd: "IDENTITYPROOF",
      ReceivedStatusCd: "PENDING",
      Frontend_msg: "Please upload valid identity proof ",
    },
    {
      DocCategoryCd: "KYCADDRESSPROOF",
      DocumentCd: "ADDRESSPROOF",
      ReceivedStatusCd: "PENDING",
      Frontend_msg: "Please upload valid Address proof",
    },
    {
      DocCategoryCd: "PHOTO",
      DocumentCd: "PHOTO",
      ReceivedStatusCd: "PENDING",
      Frontend_msg: "Please upload valid Photograph",
    },
  ];
  if (!data) data = null_condition;
  if (
    data.length > 0 &&
    (data[0].ReceivedStatusCd === null || data[0].ReceivedStatusCd === "")
  ) {
    return null;
  }

  const statusToCheck = [
    "COMPLETED",
    "RECEIVED",
    "APPROVED",
    "DIGITALAPPROVED",
  ];

  const keyToCheck = ["IDENTITYPROOF", "KYCADDRESSPROOF", "PHOTO"];

  const newData = data.filter((ei) => {
    return keyToCheck.includes(ei.DocCategoryCd);
  });

  if (newData.length === 0) return null;

  const showButton = newData.map(
    (ei) =>
      statusToCheck.includes(pendingStatus_Key(ei)?.ReceivedStatusCd) ||
      pendingStatus_Key(ei)?.ReceivedStatusCd === null
  );
  const isShowTable = showButton?.includes(false);
  return isShowTable ? (
    <>
      <Col lg={14} md={20} xs={24} style={{ margin: "20px 0px" }}>
        <CustomLabel font_size="14">KYC Documents Status</CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision container">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Document</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Document Type</CustomLabel>
            </Col>
            <Col span={12}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            {newData.map((ei, i) => {
              if (!ei || !!!ei) return null;
              return (
                <React.Fragment key={ei.DocCategoryCd}>
                  <Divider />
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {Document_key(ei?.DocCategoryCd) || ei?.DocCategoryCd}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {DocumentType_key(ei?.DocumentCd) || ei?.DocumentCd}
                    </CustomLabel>
                  </Col>
                  <Col span={12} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {pendingStatus_Key(ei)?.Frontend_msg || ei?.ReceivedStatusCd}
                    </CustomLabel>
                  </Col>
                </React.Fragment>
              );
            })}
            {showButton?.includes(false) && (
              <Col span={24} style={{ marginTop: "20px" }}>
                <FooterButton
                  nextLabel={"Upload"}
                  hideBack={true}
                  onNext={() => {
                    dispatch({ type: SET_UPLOAD_FLOW, payload: true });
                    navigate("/upload");
                  }}
                />
              </Col>
            )}
          </Row>
        </div>
      </Col>
    </>
  ) : null;
};

const AddInfoTable = ({ data }) => {
  return (
    <>
      <Col lg={24} md={20} xs={24}>
        <CustomLabel font_size="14" style={{ margin: "20px 0px" }}>
          Following is the list of additional documents required:
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={5}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={8}>
              {" "}
              <CustomLabel font_size="13">Details of Requirement</CustomLabel>
            </Col>
            <Col span={7}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            <Col span={4}>
              {" "}
              <CustomLabel font_size="13">Pending With</CustomLabel>
            </Col>
            {data.map((ei, i) => {
              const statusCode = checkDecisionPendingCode(ei?.DecisionCode) ? ei.DecisionCode : ei.InterimStatusCode;
              const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(
                    ei.DecisionCode,
                    status_code_constant_data.Add_info
                  )
                : currentStatus_Key(
                    ei.InterimStatusCode,
                    status_code_constant_data.Add_info
                  );
              return (
                <React.Fragment key={`${ei.FirstName}-${i}`}>
                  <Divider />
                  <Col span={5}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.FirstName}
                    </CustomLabel>
                  </Col>
                  <Col span={8}>
                    {""}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.AdditionalDocuments &&
                        ei.AdditionalDocuments?.length > 0 &&
                        `Please share - ${ei.AdditionalDocuments.map(
                          (e) => `${e?.DocumentSubType}`
                        ).join(",")}`}
                    </CustomLabel>
                    {ei?.UWComment && <CustomLabel style={{ marginTop: "10px"}} font_size="12" font_weight="normal">
                        <b>{`UW Comment : `}</b>{ei?.UWComment}
                    </CustomLabel>}
                  </Col>
                  <Col span={7} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {front_message_code}
                    </CustomLabel>
                  </Col>
                  {statusCode && (
                    <Col span={4}>
                      {" "}
                      <CustomLabel font_size="12" font_weight="normal">
                        {pendingWith_key(statusCode)}
                      </CustomLabel>
                    </Col>
                  )}
                </React.Fragment>
              );
            })}
          </Row>
        </div>
      </Col>
    </>
  );
};

const PPMCTable = ({ data }) => {
  const navigate = useNavigate();
  const handleAppointmentClick = () => {
    navigate("/appointment-booking")
  }
  const isEqual = (key, value) => {
    return key?.toLowerCase() === value?.toLowerCase()
  }
  const isPPMC = data?.some((i) => {
    const statusCode = checkDecisionPendingCode(i?.DecisionCode) ? i?.DecisionCode : i?.InterimStatusCode;
    return isEqual(statusCode, "PPMC Pending") || isEqual(statusCode, "PPMC Pending + Add Info Recevied") || isEqual(statusCode, "PPMC + Add Info Pending")
  });
  //For Mock Members Array START
  // const data2 = [
  //   {
  //     medicalTestDescriptionForHA: "Medical Examination Report",
  //     CustomerId: "3000153076",
  //     MemberId: "12881111401",
  //     FirstName: "Jagdeep",
  //     MiddleName: "Gorakhanatha",
  //     LastName: "Dubashi",
  //     PED: "",
  //     SpecialCondition: null,
  //     MedicalTestSet: "Set_0001",
  //     toBeAdded: [
  //       {
  //         MemberId: "12881111402",
  //         FirstName: "Arun",
  //       },
  //     ],
  //     MedicalTestSetName: "MER- Basic",
  //     Additional_test: null,
  //     Additional_test_Set: null,
  //     AdditionalDocuments: [],
  //     DecisionCode: null,
  //     InterimStatusCode: "PPMC Pending",
  //     NextStep: null,
  //     ProposedChangeCounterOffer: null,
  //     ProposedChangeCounterOfferDescription: null,
  //     PremiumLoadingAmount: 0,
  //     Deductible: "",
  //     Copay: 0,
  //     InsuredInitial: "MR",
  //     InsuredState: null,
  //     InsuredCity: "",
  //     InsuredDob: "03/01/1997",
  //     InsuredAge: 27,
  //     InsuredGender: "MALE",
  //     AppointmentDetails: {
  //       Status: "APPOINTMENTPENDING"
  //     },
  //   },
  //   {
  //     medicalTestDescriptionForHA: "Medical Examination Report",
  //     CustomerId: "3000153077",
  //     MemberId: "12881111402",
  //     FirstName: "Arun",
  //     MiddleName: "Narendra",
  //     LastName: "Kaur",
  //     PED: "",
  //     SpecialCondition: null,
  //     MedicalTestSet: "Set_0001",
  //     toBeAdded: [
  //       {
  //         MemberId: "12881111401",
  //         FirstName: "Jagdeep",
  //       },
  //     ],
  //     MedicalTestSetName: "MER- Basic",
  //     Additional_test: null,
  //     Additional_test_Set: null,
  //     AdditionalDocuments: [],
  //     DecisionCode: null,
  //     InterimStatusCode: "PPMC Pending",
  //     NextStep: null,
  //     ProposedChangeCounterOffer: null,
  //     ProposedChangeCounterOfferDescription: null,
  //     PremiumLoadingAmount: 0,
  //     Deductible: "",
  //     Copay: 0,
  //     InsuredInitial: "MR",
  //     InsuredState: null,
  //     InsuredCity: "",
  //     InsuredDob: "09/11/1996",
  //     InsuredAge: 27,
  //     InsuredGender: "MALE",
  //     AppointmentDetails: {
  //       Status: "IDPROOFMATCHING"
  //     },
  //   },
  // ];
  //For Mock Members Array END
  const isShowPendingColumn = data?.some((e) => (e?.AppointmentDetails && getAppointmentWiseStatus(e?.AppointmentDetails?.Status)?.isPendingWith) || !e?.AppointmentDetails)
  const isHidePendingColumn  = (isPPMC && isShowPendingColumn === false);
  const isHideBookAppointmentCTA = isPPMC && data?.some((e) => ((e?.AppointmentDetails && getAppointmentWiseStatus(e?.AppointmentDetails?.Status)?.isAppointmentButton) || !e?.AppointmentDetails?.Status))
  return (
    <>
      <Col lg={24} md={24} xs={24} style={{ margin: "20px 0px" }}>
        <CustomLabel font_size="14">
          Following medicals are required to be conducted at the Company’s
          authorized medical center and the cost of medical examination will be
          borne by us.{" "}
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div
          className={isPPMC ? "cg-table-decision-extra" : "cg-table-decision"}
        >
          <Row gutter={[{ lg: 8, md: 6, xs: 8 }, 0]}>
            <Col span={4} xs={6} md={5} lg={5}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={6} xs={6} md={8} lg={9}>
              {" "}
              <CustomLabel font_size="13">Details of Requirement</CustomLabel>
            </Col>
            <Col span={5} xs={6} md={6} lg={isHidePendingColumn ? 9 : 6}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
           {isHidePendingColumn ? null : <Col span={4} xs={6} md={5} lg={4}>
              {" "}
              <CustomLabel font_size="13">Pending with</CustomLabel>
            </Col>}
          </Row>
          <Divider />
              {data?.map((ei, i) => {
                const statusCode = checkDecisionPendingCode(ei?.DecisionCode) ? ei?.DecisionCode : ei?.InterimStatusCode;
                const StatusObj = ei?.AppointmentDetails ? getAppointmentWiseStatus(ei?.AppointmentDetails?.Status) : null;
                const frontend_obj = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(
                    ei.DecisionCode,
                    status_code_constant_data.PPMC
                  )
                : currentStatus_Key(
                    ei.InterimStatusCode,
                    status_code_constant_data.PPMC
                  );
                const front_message_code = StatusObj ? StatusObj?.msg : frontend_obj;
                const pendingWithMsg = isPPMC && StatusObj ? StatusObj?.pendingMsg : pendingWith_key(statusCode);
                return (
                  <Row key={i+"ppmc"} gutter={[{ lg: 8, md: 6, xs: 8 }]} className="mb-20">
                    <React.Fragment key={`${ei.DocCategoryCd}-${i}`}>
                      <Col span={4} xs={6} md={5} lg={5}>
                        {" "}
                        <CustomLabel font_size="12" font_weight="normal">
                          {ei?.FirstName}
                        </CustomLabel>
                      </Col>
                      <Col span={6} xs={6} md={8} lg={9}>
                        {" "}
                        <CustomLabel font_size="12" font_weight="normal">
                          {ei?.MedicalTestSetName || ei?.MedicalTest}
                        </CustomLabel>
                      </Col>
                      <Col
                        span={5}
                        xs={6}
                        md={6}
                        lg={6}
                        style={{ wordBreak: "break-word" }}
                        className="mb-10"
                      >
                        {" "}
                        <CustomLabel font_size="12" font_weight="normal">
                          {front_message_code}
                        </CustomLabel>
                      </Col>
                      {isHidePendingColumn ? null : statusCode && (
                        <Col span={4} xs={6} md={5} lg={4}>
                          {" "}
                          <CustomLabel font_size="12" font_weight="normal">
                            {pendingWithMsg}
                          </CustomLabel>
                        </Col>
                      )}
                    </React.Fragment>
                  </Row>
                );
              })}
        </div>
      </Col>
      {isHideBookAppointmentCTA && (
              <Col
                xs={24}
                className="mb-20"
              >
                <BookAppointmentSmallButton
                  disable={false}
                  className="ppmc-table-btn"
                >
                  <Button
                    onClick={handleAppointmentClick}
                    type="text"
                    disabled={false}
                  >
                    {"Book Appointment"}
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      style={{ marginLeft: "5px" }}
                    />
                  </Button>
                </BookAppointmentSmallButton>
              </Col>
            )}
    </>
  );
};

const SpecialConditionTable = ({ data, callback }) => {
  const specialConditionMsgArr = data.map((ei, i) => {
    const front_message_code =  checkDecisionPendingCode(ei?.DecisionCode)
    ? currentStatus_Key(
        ei.DecisionCode,
        status_code_constant_data.SpecialCondition
      )
    : currentStatus_Key(
        ei.InterimStatusCode,
        status_code_constant_data.SpecialCondition
      );
   return {
      MemberId: ei?.MemberId,
      msg: front_message_code,
      reason: ei?.AddField4 || ""
    };
  });
  //Calling callback for dispatch
  callback({
       isSpecialCondition: true,
       specialConditionMsg: specialConditionMsgArr
  });
  return (
    <>
      <Col lg={24} md={24} xs={24} style={{ margin: "20px 0px" }}>
        <CustomLabel font_size="14">
          Following are the exclusions to the policy
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={5}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={7}>
              {" "}
              <CustomLabel font_size="13">Details of requirement</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Reason</CustomLabel>
            </Col>
            {data.map((ei, i) => {
              const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(
                    ei.DecisionCode,
                    status_code_constant_data.SpecialCondition
                  )
                : currentStatus_Key(
                    ei.InterimStatusCode,
                    status_code_constant_data.SpecialCondition
                  );

              return (
                <React.Fragment key={`${ei.DocCategoryCd}-${i}`}>
                  <Divider />
                  <Col span={5}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.FirstName}
                    </CustomLabel>
                  </Col>
                  <Col span={7}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.SpecialCondition}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {front_message_code}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei?.AddField4}
                    </CustomLabel>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </div>
      </Col>
    </>
  );
};

const LoadingTable = ({ data, PremiumUWloading, premiumToBeCollected, TotalUWLoading, callback }) => {
  const loadingMsgArr = data.map((ei, i) => {
      const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
        ? currentStatus_Key(
            ei.DecisionCode,
            status_code_constant_data.Loading
          )
        : currentStatus_Key(
            ei.InterimStatusCode,
            status_code_constant_data.Loading
          );
          return {
            MemberId: ei?.MemberId,
            msg: front_message_code,
            reason: ei?.AddField4 || ""
          };
    });
 //Calling callback for dispatch
  callback({
    isLoading: true,
    loadingMsg: loadingMsgArr,
  });
  return (
    <>
      <Col lg={24} md={24} xs={24} style={{ margin: "20px 0px" }}>
        <CustomLabel font_size="14">
          An additional premium amounting to Rs. {TotalUWLoading} is applicable
          as explained in table below.
        </CustomLabel>
        <CustomLabel font_size="14" style={{ marginTop: "10px" }}>
          Total Amount Payable: Rs. {premiumToBeCollected}
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Details of requirement</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Reason</CustomLabel>
            </Col>
            {data.map((ei, i) => {
              const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(
                    ei.DecisionCode,
                    status_code_constant_data.Loading
                  )
                : currentStatus_Key(
                    ei.InterimStatusCode,
                    status_code_constant_data.Loading
                  );
              return (
                <React.Fragment key={`${ei.DocCategoryCd}-${i}`}>
                  <Divider />
                  <Col span={6}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.FirstName}
                    </CustomLabel>
                  </Col>
                  <Col span={6}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.PED}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {front_message_code}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei?.AddField4}
                    </CustomLabel>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </div>
      </Col>
    </>
  );
};

const CounterOfferTable = ({ data, type, callback }) => {
  const getDeductibleAmountFromCode = (code) => {
    return code ? code?.split("DED")[1]?.replace("K","000") : "";
  }
  const removeMinus = (amount) => {
    return amount?.toString() ? amount?.toString()?.replace("-","") : "";
  }
  const displayMsg = (data) => {
    switch (type) {
      case status_code_constant_data.CounterOffer:
        return `${data["ProposedChangeCounterOfferDescription"]}`;
      case status_code_constant_data.Deductible:
        if (!data["Deductible"] || data["Deductible"] === "") return false;
        return `Deductible of ₹${getDeductibleAmountFromCode(
          data["Deductible"]
        )} is applied to the policy and an amount of ₹${removeMinus(
          data["DeductibleAmount"]
        )} will be adjusted with the premium of your policy.`;
      case status_code_constant_data.CoPayment:
        if (!data["Copay" || data["Copay"] !== ""]) return false;
        return `Copay of ${data["Copay"]} %`;
    }
  };
  const MsgArr = data.map((ei, i) => {
    const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
      ? currentStatus_Key(ei.DecisionCode, type)
      : currentStatus_Key(ei.InterimStatusCode, type);
    return {
      MemberId: ei?.MemberId,
      msg: front_message_code,
      reason: ei?.AddField4 || ""
    };
  });
  const keyList = {
    [status_code_constant_data.CounterOffer]: 'isCounterOffer',
    [status_code_constant_data.CoPayment]: 'isCopay',
    [status_code_constant_data.Deductible]: 'isDeductible',
  }
  const msgKeyList = {
    [status_code_constant_data.CounterOffer]: 'counterOfferMsg',
    [status_code_constant_data.CoPayment]: 'copayMsg',
    [status_code_constant_data.Deductible]: 'deductibleMsg',
  }

  //Calling callback for dispatch
  callback({
    [keyList[type]]: true,
    [msgKeyList[type]]: MsgArr,
  });

  return (
    <>
      <Col lg={24} md={24} xs={24} style={{ margin: "20px 0px" }}>
        <CustomLabel font_size="14">
          The revised terms are / is as follows:
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Details of requirement</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            <Col span={6}>
              {" "}
              <CustomLabel font_size="13">Reason</CustomLabel>
            </Col>
            {data.map((ei, i) => {
              const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(ei.DecisionCode, type)
                : currentStatus_Key(ei.InterimStatusCode, type);
              return (
                <React.Fragment key={`${ei.DocCategoryCd}-${i}`}>
                  <Divider />
                  <Col span={6}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.FirstName}
                    </CustomLabel>
                  </Col>
                  <Col span={6}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {!!displayMsg(ei) && displayMsg(ei)}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {front_message_code}
                    </CustomLabel>
                  </Col>
                  <Col span={6} style={{ wordBreak: "break-all" }}>
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei?.AddField4}
                    </CustomLabel>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </div>
      </Col>
    </>
  );
};

const TeleUWTable = ({ data }) => {
  const { policyNum, proposalDetails } = PolicyDetails();
  const [openModal, setOpenModal] = useState(false);
  const toggleModal = () => {
    setOpenModal(!openModal);
  }
  const payload = {
    pno: policyNum?.trim(),
    source: "appTrackerV1",
    mobileNo: proposalDetails?.ProposerMobile,
  };
  const encryptedPayload = encrypt(JSON?.stringify(payload));
  const navigate = useNavigate();
  const handleAppointmentClick = () => {
      navigate("/tele-medical-booking")
  }
  const onClickSubmitHealthButton = () => {
    const newLink = '/telemedical/new?q=';
    window.open(`${newLink}${encryptedPayload}`, '_blank', 'noopener noreferrer');
  }
  const handleSubmitDisclosureClick = () => {
      toggleModal();
      setTimeout(() => {
        onClickSubmitHealthButton();
      },500)
  }
  return (
    <>
      <Col lg={24} md={20} xs={24}>
        <CustomLabel font_size="14" style={{ margin: "20px 0px" }}>
          Tele underwriting :
        </CustomLabel>
      </Col>
      <Col lg={24} md={24} xs={24}>
        <div className="cg-table-decision">
          <Row gutter={[{ lg: 6, md: 6, xs: 8 }, 0]}>
            <Col span={5}>
              {" "}
              <CustomLabel font_size="13">Name of Insured</CustomLabel>
            </Col>
            <Col span={0}>
              {" "}
              <CustomLabel font_size="13">Details of Requirement</CustomLabel>
            </Col>
            <Col span={10}>
              {" "}
              <CustomLabel font_size="13">Status</CustomLabel>
            </Col>
            <Col span={4}>
              {" "}
              <CustomLabel font_size="13">Pending With</CustomLabel>
            </Col>
            {data.map((ei, i) => {
              const statusCode = checkDecisionPendingCode(ei?.DecisionCode) ? ei?.DecisionCode : ei?.InterimStatusCode;
              const front_message_code = checkDecisionPendingCode(ei?.DecisionCode)
                ? currentStatus_Key(
                    ei.DecisionCode,
                    status_code_constant_data.TeleUW
                  )
                : currentStatus_Key(
                    ei.InterimStatusCode,
                    status_code_constant_data.TeleUW
                  );
              return (
                <React.Fragment key={`${ei.FirstName}-${i}`}>
                  <Divider />
                  <Col span={5}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {ei.FirstName}
                    </CustomLabel>
                  </Col>
                  <Col span={0}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {/* {ei.AdditionalDocuments} */}
                    </CustomLabel>
                  </Col>
                  <Col span={10} style={{ wordBreak: "break-all" }}>
                    {" "}
                    <CustomLabel font_size="12" font_weight="normal">
                      {front_message_code}
                    </CustomLabel>
                  </Col>
                  {statusCode && (
                    <Col span={4}>
                      <CustomLabel font_size="12" font_weight="normal">
                        {pendingWith_key(statusCode)}
                      </CustomLabel>
                    </Col>
                  )}
                </React.Fragment>
              );
            })}
          </Row>
        </div>
      </Col>
      {true && (
              <Col
                xs={24}
                className="mb-20"
              >
                <div className="flex-space-between">
                <SubmitHealthButton
                  disable={false}
                  className="ppmc-table-btn"
                >
                  <Button
                    onClick={onClickSubmitHealthButton}
                    type="text"
                    disabled={false}
                  >
                    {"Submit Health Disclosure"}
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      style={{ marginLeft: "5px" }}
                    />
                  </Button>
                </SubmitHealthButton>
                <BookOutlinedButton
                  disable={false}
                  className="ppmc-table-btn"
                >
                  <Button
                    onClick={toggleModal}
                    type="text"
                    disabled={false}
                  >
                    {"Book Appointment"}
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      style={{ marginLeft: "5px" }}
                    />
                  </Button>
                </BookOutlinedButton>
                </div>
              </Col>
            )}
        <TeleModal
          open={openModal}
          onClose={toggleModal}
          onSubmitHealthDisclosure={handleSubmitDisclosureClick}
          onBooking={handleAppointmentClick}
        />
    </>
  );
};

export {
  PendingTable,
  AddInfoTable,
  PPMCTable,
  SpecialConditionTable,
  LoadingTable,
  CounterOfferTable,
  TeleUWTable,
};
